import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'ppl-view-ledger',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './view-patient-ledger.component.html',
  styleUrl: './view-patient-ledger.component.css'
})
export class ViewPatientLedgerComponent {

}
